import { withStyles } from '@material-ui/core/styles';

export default withStyles;
